import React, { Component, Fragment } from "react";
import { Route, Switch } from "react-router";
import { ConnectedRouter } from "connected-react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import DocumentTitle from "react-document-title";
import PropTypes from "prop-types";

import Signin from "../pages/signin";
import Signup from "../pages/signup";
import AuthToken from "../pages/authToken";
import CreditCard from "../pages/creditCard";
import Passowrd from "../pages/password";
import resetPassowrd from "../pages/resetPassword";
import pinPassowrd from "../pages/pinPassword";
import userConfirmation from "../pages/userConfirmation";

import Home from "../pages/home";
import Newspapers from "../pages/newspapers";
import Newspaper from "../pages/newspaper";
import DownloadApp from "../pages/downloadApp";
import PoliticaDePrivacidade from "../pages/politicaDePrivacidade";
import TermosDeUso from "../pages/termosDeUso";
import Faq from "../pages/faq";

import LPSubscription from "../pages/lps/subscription";

import AdminUser from "../pages/admin/user";
import AdminSubscription from "../pages/admin/subscription";
import AdminPayment from "../pages/admin/payment";
import AdminCards from "../pages/admin/cards";
import AdminVouchers from "../pages/admin/vouchers";

import Application from "../layouts/application";
import Clean from "../layouts/clean";
import Admin from "../layouts/admin";
import LP from "../layouts/lp";

import ScrollToTop from "../components/ScrollToTop";
import URLFilter from "../components/URLFilter";

import { Creators as SiteCreators } from "../store/ducks/sites";
import { Creators as UserCreators } from "../store/ducks/user";

class Router extends Component {
  static propTypes = {
    // site: PropTypes.shape.isRequired,
    getSiteRequest: PropTypes.func.isRequired,
    refrashUser: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
    // history: PropTypes.shape.isRequired,
  };

  componentWillMount = () => {
    this.props.getSiteRequest();
    this.props.refrashUser();
  };

  render() {
    if (this.props.site.data.favicon) {
      document.querySelector(
        "link[rel*='icon']"
      ).href = this.props.site.data.favicon;
    }

    const authRoutes = [
      // {
      //   path: '/',
      //   page: Signin,
      // },
      {
        path: "/signin",
        page: Signin
      },
      {
        path: "/credit-card",
        page: CreditCard
      },
      {
        path: "/embeded/credit-card",
        page: CreditCard
      },
      {
        path: "/signup",
        page: Signup
      },
      {
        path: "/signup/:voucher",
        page: Signup
      },
      {
        path: "/signup/auth/:token",
        page: AuthToken
      },
      {
        path: "/password/new",
        page: Passowrd
      },
      {
        path: "/password/pin",
        page: pinPassowrd
      },
      {
        path: "/password/edit/:token",
        page: resetPassowrd
      },
      {
        path: "/users/confirmation/:token",
        page: userConfirmation
      }
    ];

    const adminRoutes = [
      {
        path: "/",
        page: AdminSubscription
      },
      {
        path: "/admin",
        page: AdminSubscription
      },
      {
        path: "/admin/user",
        page: AdminUser
      },
      {
        path: "/admin/payments",
        page: AdminPayment
      },
      {
        path: "/admin/cards",
        page: AdminCards
      },
      {
        path: "/admin/vouchers",
        page: AdminVouchers
      }
    ];

    const LPRoutes = [
      {
        path: "/assine",
        page: LPSubscription
      }
    ];

    const routes = [
      {
        path: "/home",
        page: Home
      },
      {
        path: "/jornais/:uf",
        page: Newspapers
      },
      {
        path: "/jornal/:id/:name/:edition_id",
        page: Newspaper
      },
      {
        path: "/jornal/:id/:name",
        page: Newspaper
      },
      {
        path: "/download-app",
        page: DownloadApp
      },
      {
        path: "/politica-de-privacidade",
        page: PoliticaDePrivacidade
      },
      {
        path: "/termos-de-uso",
        page: TermosDeUso
      },
      {
        path: "/duvidas",
        page: Faq
      },
      // Rotas abaixo para manter legado de acesso do SITE ANTIGO
      {
        path: "/termosDeUso",
        page: TermosDeUso
      },
      {
        path: "/privacidade",
        page: PoliticaDePrivacidade
      }
    ];

    return (
      <DocumentTitle title={this.props.title}>
        <Fragment>
          <ConnectedRouter history={this.props.history}>
            <ScrollToTop>
              <URLFilter privateURLs={adminRoutes}>
                <Switch>
                  {routes.map(route => (
                    <Route
                      key={route.path}
                      exact
                      path={route.path}
                      render={props => (
                        <Application {...props} page={route.page} />
                      )}
                    />
                  ))}
                  {adminRoutes.map(route => (
                    <Route
                      key={route.path}
                      exact
                      path={route.path}
                      render={props => <Admin {...props} page={route.page} />}
                    />
                  ))}
                  {authRoutes.map(route => (
                    <Route
                      key={route.path}
                      exact
                      path={route.path}
                      render={props => <Clean {...props} page={route.page} />}
                    />
                  ))}
                  {LPRoutes.map(route => (
                    <Route
                      key={route.path}
                      exact
                      path={route.path}
                      render={props => <LP {...props} page={route.page} />}
                    />
                  ))}
                </Switch>
              </URLFilter>
            </ScrollToTop>
          </ConnectedRouter>
          {!!this.props.site.data.custom_css && (
            <style type="text/css">{this.props.site.data.custom_css}</style>
          )}
        </Fragment>
      </DocumentTitle>
    );
  }
}

const mapStateToProps = state => ({
  site: state.sites,
  title: state.sites.data.name
    ? `${state.sites.data.name} - ${state.sites.data.description}`
    : "Carregando..."
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...SiteCreators, ...UserCreators }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Router);



// WEBPACK FOOTER //
// ./src/routes/index.js